import { asyncRoutes, constantRoutes } from "@/router";

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  const latch = route.meta?.latch;
  let pass = true;

  if (latch) {
    pass = roles.some((role) => latch.includes(role));
  }

  return pass;

  // if (route.meta && route.meta.roles) {
  //   return roles.some((role) => route.meta.roles.includes(role));
  // } else {
  //   return true;
  // }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };

    const pass = hasPermission(roles, tmp);

    // 如果父级权限通过了，默认子级全部通过
    if (!pass && tmp.children) {
      tmp.children = filterAsyncRoutes(tmp.children, roles);
    }

    if (pass || tmp.children?.length > 0) {
      res.push(tmp);
    }

    // if (hasPermission(roles, tmp)) {
    //   if (tmp.children) {
    //     tmp.children = filterAsyncRoutes(tmp.children, roles);
    //   }
    //   res.push(tmp);
    // }
  });

  return res;
}

const state = {
  routes: [],
  addRoutes: [],
};
const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }, roles) {
    let accessedRoutes = [];

    if (roles.includes("admin")) {
      accessedRoutes = asyncRoutes;
    } else {
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
    }

    commit("SET_ROUTES", accessedRoutes);

    return accessedRoutes;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
